import { GridCellParams, GridTreeNode } from '@mui/x-data-grid';

import { InvoiceStages } from 'openapi';

import { useTranslations } from 'context/TranslationContext';

import {
  DEFAULT_COMPANY_REGISTRATION_NUMBER,
  DRAFT_INVOICE_STYLE,
  CHECK
} from 'utils/constants/constants';
import { SEVERITY_COLORS } from 'utils/constants/invoices';

export const getColumnValue = (value: any) => {
  return value || '';
};

export const useDataGridHelpers = () => {
  const { translate } = useTranslations();

  const getCounterPartyTypeValue = (value: any) => {
    const type = value.toLowerCase();

    return translate(`labels.${type}`);
  };

  const getNameValue = (value: any) => {
    const { name } = value;

    return name || translate('labels.loading');
  };

  const getPercentageValue = (value: any) => {
    return `${value * 100}%`;
  };

  const getYesNoValue = (value: any) => {
    return value ? translate('labels.yes') : translate('labels.no');
  };

  const getExpenseTypeValue = (value: any) => value?.expenseType;

  const getCompanyRegistrationNumberValue = (value: any, row: any) => {
    const { withoutCompanyRegistrationNumber } = row;

    return withoutCompanyRegistrationNumber
      ? DEFAULT_COMPANY_REGISTRATION_NUMBER
      : value;
  };

  const getCellValue = (value: any) => value?.value;

  const getTransactionCellClassName = (
    params: GridCellParams<any, any, any, GridTreeNode>
  ) => {
    if (params.field !== CHECK && !params.row[params.field]?.isValid) {
      return DRAFT_INVOICE_STYLE;
    }
    return '';
  };

  const getSeverityColor = (value: InvoiceStages) => {
    return (
      SEVERITY_COLORS[value] || {
        color: 'rgba(0, 0, 0, 0.75)',
        backgroundColor: 'rgba(153,153,153,0.1)'
      }
    );
  };

  return {
    getPercentageValue,
    getCounterPartyTypeValue,
    getYesNoValue,
    getExpenseTypeValue,
    getNameValue,
    getCompanyRegistrationNumberValue,
    getCellValue,
    getTransactionCellClassName,
    getSeverityColor
  };
};
